import axios from "axios";
import NProgress from "nprogress";
import store from "@/store";
import router from "@/router";

const API_URL = process.env.VUE_APP_API_BASE_POINT;

// create a new axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// before a request is made start the nprogress
axiosInstance.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

// before a response is returned stop nprogress
axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();
    if (response.data.message === "Unauthorized.") {
      httpUnauthorized();
    }
    return response;
  },
  (error) => {
    NProgress.done();
    if (error.response && error.response.data === "Unauthorized.") {
      httpUnauthorized();
    }
    return Promise.reject(error);
  }
);

function httpUnauthorized(){
  store.dispatch("keepSignedIn/keepSign", false);
  store.dispatch("auth/logout");
  router.push({ path: "/signin" });
}

export default axiosInstance;
